import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { LocationWiseTranfers } from "./location-wise-transfers.entity";
import { TransferInfo } from "./transfer-material.entity";

@Entity('transferred_items')
export class TransferItems {
    @PrimaryGeneratedColumn("increment", { name: 'transferred_item_id' })
    packingStockTransferId: number;

    @Column("int", {
        nullable: false,
        name: "sale_order_id",
        default:0
    })
    saleOrderId: number;

    @Column("int", {
        nullable: false,
        name: "item_category_id"
    })
    itemCategoryId: number;

    @Column("int", {
        nullable: false,
        name: "item_sub_category_id"
    })
    itemSubCategoryId: number;

    @Column("int", {
        nullable: false,
        default:0,
        name: "item_id"
    })
    itemId: number;

    // @Column("int", {
    //     nullable: false,
    //     name: "size_id"
    // })
    // sizeId: number;

    @Column("decimal", {
        nullable: false,
        name: "ip_quantity",
        default:0,
        unsigned:true,
        precision:10,scale:3,
    })
    ipQty: number;

    @Column("decimal", {
        nullable: false,
        name: "transferred_quantity",
        default:0,
        unsigned:true,
        precision:10,scale:3,
    })
    transferredQty: number;

    @Column("decimal", {
        nullable: false,
        name: "op_quantity",
        default:0,
        unsigned:true,
        precision:10,scale:3,
    })
    opQty: number;

    @Column("decimal", {
        nullable: false,
        name: "unit_price",
        precision:10,scale:3,
        unsigned:true,
        default:0
    })
    unitPrice: number;
    
    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "stock_ids"
    })
    stockIds: string;
    @Column("varchar", {
        nullable: false,
        length: 40,
        name: "receive_stock_ids"
    })
    receiveStockIds: string;

    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({ name: "updated_at" })
    updatedAt: Date;


    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "status"
    })
    isActive: boolean | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
  
    @OneToMany(type => LocationWiseTranfers, res => res.locationInfo, { cascade: true })
    locationstockTransferItems: LocationWiseTranfers[];

    @ManyToOne(type => TransferInfo, trans => trans.stockTransferItems, { nullable: false })
    @JoinColumn({ name: "transfer_id" })
    poCreationInfo: TransferInfo[];
}